import { random, round2Str } from "../helpers/helpers";
import { vibrationRegistry } from "./vibrationRegistry";

export const generateVibrationLastFifteenDemo = ({ meter_id }) => {
    let motor;

    vibrationRegistry.areas.forEach((a) =>
        a.machines.forEach((m) =>
            m.motors.forEach((mo) => {
                if (mo.id === Number(meter_id)) motor = mo;
            })
        )
    );

    if (!motor) return [];

    const now = new Date();
    const data = [];

    let baseVelocity = random(
        motor.limits.normal * 0.6,
        motor.limits.normal * 0.9
    );
    let baseAcc = baseVelocity * random(0.25, 0.4);
    let baseTemp = random(
        motor.limits.temp_normal - 3,
        motor.limits.temp_normal + 3
    );

    for (let i = 0; i < 15; i++) {
        const t = new Date(now.getTime() - i * 2 * 60 * 1000);

        baseVelocity += random(-0.15, 0.15);
        baseAcc += random(-0.04, 0.04);
        baseTemp += random(-0.2, 0.2);

        data.push({
            dtime: `${t.getFullYear()}-${String(t.getMonth() + 1).padStart(
                2,
                "0"
            )}-${String(t.getDate()).padStart(2, "0")} ${String(
                t.getHours()
            ).padStart(2, "0")}:${String(t.getMinutes()).padStart(
                2,
                "0"
            )}:${String(t.getSeconds()).padStart(2, "0")}`,

            velocity_axis1: round2Str(baseVelocity),
            velocity_axis2: round2Str(baseVelocity + random(-0.1, 0.1)),
            velocity_axis3: round2Str(baseVelocity + random(-0.1, 0.1)),

            acc_x: round2Str(baseAcc),
            acc_y: round2Str(baseAcc * random(0.9, 1.1)),
            acc_z: round2Str(baseAcc * random(1.0, 1.2)),

            temperature: round2Str(baseTemp),
            normal_limit: round2Str(motor.limits.normal),
            marginal_limit: round2Str(motor.limits.marginal),
        });
    }

    return data;
};
